
  import Vue from 'vue';
  import {
    WithContext,
    Product
  } from 'schema-dts';
  import HelpCard from '@/components/HelpCard';
  import tableLoading from '@/components/tableLoading';
  export default {
    scrollToTop: true,
    head() {
      return {
        title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of "Stotra" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of "Stotra" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'स्तोत्र संग्रह, Ganpati stotra, hanuman stotra, maruti stotra, Ramraksha Stotra, Vyankatesh Stotra, shiv-stuti, mahalakshmi, Krishnashtakam, guru charitra'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'स्तोत्र संग्रह, stotra sangrah, all stotra lyrics, list of all stotra, stotra, Ganpati Athrvashirsha, Sankat Nashanam Ganesha Stotra, Ganapati Stotra, Shri Ganesh Chalisa, Hanuman Chalisa, Ramraksha Stotra, Vyankatesh Stotra, Vishnu Shatanama Stotra, Shiv Stuti, Mahalakshmi Ashtakam, Ghorkashtodharan Stotra, Swami Samarth Ashtak, Guru Charitra, Maruti Stotra, Tarak Mantra, Krishnashtakam, Shubham Karoti, Marathi stotras, English stotras' 
          },
          {
            hid: 'image',
            property: 'image',
            // content: this.$config.siteUrl + '/img/stotra/.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            // content: this.$config.siteUrl + '/img/stotra/.webp'
          },
        ],
      }
    },
    // jsonld() {
    //   const items = this.faqData.map((item, index) => ({
    //     '@type': 'Question',
    //     position: index + 1,
    //     "name": item.question,
    //     "acceptedAnswer": {
    //       "@type": "Answer",
    //       "text": item.answer
    //     },
    //   }));
    //   return {
    //     '@context': 'https://schema.org',
    //     '@type': 'FAQPage',
    //     mainEntity: items,
    //   };
    // },

    jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          // "@id": "https://goa.app/stotra/"
        },
        "headline": "Shree Ganesh Stotra - Stotra",
        "name" :"Shree Ganesh Stotra - Stotra",
        "description": "Explore the full lyrics of 'stotra' in both Marathi and English, with an option to switch between the two languages.",
        // "image": this.$config.siteUrl + '/img/stotra/.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },

    components: {
      HelpCard,
      tableLoading
    },
    data() {
      return {
        title: 'Shree Ganesh Stotra | Stotra - श्री गणेश स्तोत्र',
        faqData: [],
        search: '',
        loading: true,
      }
    },
    layout: 'detailsPage-withoutFooter',
    fetchOnServer: false,
    computed: {
    }

  }
